import TablePage from '../../../../../components/table_page';
// import DatePicker from '../../../components/datePicker';
// import viewDetail from '../../../components/viewDetail.vue';
import Form from './form/index';

export default {
  name: 'table-component',
  extends: TablePage,
  components: {
    Form,
  },
  data() {
    return {
      // formName: 'viewDetail',
    };
  },
  methods: {
    beforeSearchEvent({
      $event,
    }) {
      if ($event.type === 'reset') {
        const today = new Date();
        const year = today.getFullYear();
        const month = String(today.getMonth() + 1).padStart(2, '0');
        const day = String(today.getDate()).padStart(2, '0');
        const executeStartTime = `${year}-${month}-${day} 00:00:00`;
        const executeEndTime = `${year}-${month}-${day} 23:59:59`;
        this.searchFormData = {
          ...this.searchFormData,
          executeStartTime,
          executeEndTime,
        };
        this.formData = {
          ...this.formData,
          executeStartTime,
          executeEndTime,
        };
      }
      return true;
    },
    afterGetList() {
      // 第 2~11 次时间字段，与 pickupsPhotoRespVos 下标 0~9 依次对应
      const timeFields = [
        'secondTimes', 'thirdTimes', 'fourthTimes', 'fifthTimes', 'sixthTimes',
        'seventhTimes', 'eighthTimes', 'ninthTimes', 'tenthTimes', 'eleventhTimes',
      ];
      this.tableData = this.tableData.map((v) => {
        const metadataVos = v.metadataVos || [];
        const firstTimes = metadataVos
          .filter((item) => item.type === 'DISPLAY')
          .map((item) => item.lastModified)
          .join(',');
        // PICKUPS 图片按 url 建立时间映射，用于匹配各次补拍照片
        const pickupsTimeMap = {};
        metadataVos
          .filter((item) => item.type === 'PICKUPS')
          .forEach((item) => {
            if (item.fileUrl) {
              pickupsTimeMap[item.fileUrl] = item.lastModified;
            }
          });
        const pickupsList = v.pickupsPhotoRespVos || [];
        const times = {};
        timeFields.forEach((field, index) => {
          const group = pickupsList[index] || {};
          const photos = group.photos || [];
          times[field] = photos
            .map((url) => pickupsTimeMap[url])
            .filter((time) => time)
            .join(',');
        });
        return {
          ...v,
          firstTimes,
          ...times,
        };
      });
    },
    modalClick({
      val,
      row,
    }) {
      const {
        code,
      } = val;
      if (code === 'view') {
        this.modalConfig.title = '详情';
        this.formName = 'Form';
        this.formConfig = {
          name: 'CLF',
          code,
          row,
        };
        this.openFull();
      }
    },
  },
  async created() {
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    const executeStartTime = `${year}-${month}-${day} 00:00:00`;
    const executeEndTime = `${year}-${month}-${day} 23:59:59`;
    this.searchFormData = {
      ...this.searchFormData,
      executeStartTime,
      executeEndTime,
    };
    await this.getConfigList('display_fees_report');
    this.formData = {
      ...this.formData,
      executeStartTime,
      executeEndTime,
    };
  },

};
